<template>
  <div class="params-col">
    <div v-if="mode == 'drag'">
      <!-- Aspect ratio selector -->
      <div class="params-col__item param-field">
        <div class="field-label">
          Aspect Ratio
        </div>
        <el-select
          v-model="aspectRatio"
          class="param-field__select edit-select"
          popper-class="edit-select-dropdown"
          placeholder="Select resolution"
        >
          <el-option
            v-for="r in ratios"
            :key="r.value"
            :label="r.label"
            :value="r.value"
          />
        </el-select>
      </div>
      <!-- Crop enable/disable button -->
      <div class="params-col__item param-field">
        <el-button v-if="!isCropAdded" type="success" @click="addCrop">
          Add Crop
        </el-button>
        <el-button v-else type="danger" @click="removeCrop">
          Remove Crop
        </el-button>
      </div>
    </div>
    <div v-else>
      <el-button
        class="button-container__btn fontStyle"
        type="primary"
        @click="enableDragMode"
        >Stop preview</el-button
      >
    </div>
  </div>
</template>

<script>
// import { mapState, mapMutations } from "vuex";
// @group Editing
// Crop video settings
export default {
  name: "EditCropPanel",
  props: {
    mode: {
      type: String,
      default: "drag"
    },
    // Sync aspect ratio (width/height)
    cropAspectRatio: {
      type: Number,
      default: 1,
      validator(val) {
        return [1, 0.5625, null].includes(val);
      }
    },
    // Crop added flag
    isCropAdded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      aspectRatio: this.cropAspectRatio,
      ratios: [
        {
          value: 1,
          label: "4:4",
          selected: true
        },
        {
          value: 0.5625,
          label: "9:16"
        },
        {
          value: null,
          label: "Free"
        }
      ]
    };
  },
  computed: {
    // ...mapState({ isPlaying: state => state.ndvrPlayer.isPlaying }),
  },
  watch: {
    // @vuese
    // Update aspect ratio property
    aspectRatio(ratio) {
      this.$emit("update:cropAspectRatio", ratio);
    }
  },
  methods: {
    enableDragMode(){
      this.$emit('stopPreview')
    },
    // ...mapMutations("ndvrPlayer", ["setStopPlayerNdvr"]),

    // @vuese
    // Add crop
    addCrop() {
      // "Add crop" clicked
      this.$emit("addCrop");
    },
    // @vuese
    // Hide crop
    removeCrop() {
      // "Remove crop" clicked
      // this.$store.commit("setStopPlayerNdvr", false);
      // this.setStopPlayerNdvr(false);
      this.$emit("removeCrop");
    }
  }
};
</script>

<style lang="scss"></style>
